import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { TypographyT37 } from "../Typography/index";
const Message = (props) => {
  const { message = "No Data" } = props;
  return (
    <Fragment>
      <MessageWrapper>
        <TypographyT37>{message}</TypographyT37>
      </MessageWrapper>
    </Fragment>
  );
};

export default Message;

export const MessageWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  width: 100%;
  box-shadow: 0px 0px 2px gray;
  border-radius: 10px;
`;
